<script>
import { mapActions } from "vuex";

export default {
  components: {},
  methods: {
    ...mapActions("i18N", ["setLanguageAction"]),
  },
  beforeMount() {
    // this.setLanguageAction("ar");
    document.documentElement.dir = this.getLanguage === "ar" ? "rtl" : "ltr";
  },
};
</script>

<template>
  <div>
    <!-- <div class="home-btn d-none d-sm-block">
      <router-link tag="a" to="/" class="text-dark">
        <i class="fas fa-home h2"></i>
      </router-link>
    </div> -->
    <div class="account-pages">
      <div class="container">
        <slot />
      </div>
    </div>
  </div>
</template>
